<div [formGroup]="formGroup">
  <div class="body-container" formArrayName="sections">
    @let section = sectionControls[activeSectionIndex];
    <div [attr.id]="'section' + activeSectionIndex" class="section-container" formGroupName="{{ activeSectionIndex }}">
      <div class="section-container">
        <div class="section-header">
          <div (click)="setItem(activeSectionIndex)" class="section-title-container">
            <sag-ui-input
              [label]="'template.item.sectionTitle' | translate"
              [placeholder]="'template.item.sectionPlaceholder' | translate"
              type="text"
              [formControl]="getControl(section, 'title')"
              [required]="true"
              class="section-title" />
            @if (sections.controls.length > 1) {
              <sag-ui-button icon="delete" color="danger" [square]="true" (click)="removeSection(activeSectionIndex)" />
            }
          </div>
          <div class="section-guidance" formGroupName="guidance">
            <app-editor
              [formControl]="getControl(section.controls.guidance, 'content')"
              [required]="true"
              [label]="'template.item.sectionGuidance' | translate"
              [placeholder]="'report.actions.editGuidance' | translate"
              [maxLength]="2000" />
          </div>
        </div>
        <ng-container formArrayName="areas">
          <div>
            @for (area of sectionAreas(section); track area; let areaIndex = $index) {
              <div class="main-content" formGroupName="{{ areaIndex }}">
                {{ "generic.word.question" | translate }} {{ areaIndex + 1 }}
                <sag-ui-textarea
                  [label]="'template.item.' + area.value.questionType | translate"
                  [placeholder]="'template.item.editQuestion' | translate"
                  [formControl]="getControl(area, 'description')">
                </sag-ui-textarea>
                @if (isYesNoQuestion(area)) {
                  <sag-ui-checkbox [formControl]="getControl(area, 'isExplanationDisplayed')">
                    {{ "template.item.yesNo.explanation" | translate }}
                  </sag-ui-checkbox>
                  @if (getControl(area, "isExplanationDisplayed").value === true) {
                    <sag-ui-checkbox [formControl]="getControl(area, 'isExplanationMandatory')">
                      {{ "template.item.yesNo.explanationMandatory" | translate }}
                    </sag-ui-checkbox>
                    <sag-ui-select
                      [label]="'Display for'"
                      [placeholder]="'Select a condition'"
                      [required]="true"
                      [formControl]="getControl(area, 'explanationDisplayType')">
                      @for (type of explanationDisplayType; track type) {
                        <sag-ui-option [value]="type" [selected]="type === area.value.explanationDisplayType">
                          {{ type }}
                        </sag-ui-option>
                      }
                    </sag-ui-select>
                  }
                }
                <div #addGuidanceArea [ngClass]="{ hide: !hasGuidanceValue(area) }" class="add-guidance-area">
                  <div (click)="toggleGuidanceText(addGuidanceButton, addGuidanceArea, area)" id="close-guidance-area" class="icon-close"></div>
                  <div>
                    <app-editor
                      [formControl]="getControl(area, 'guidanceText')"
                      [label]="'report.item.guidance' | translate"
                      [placeholder]="'report.actions.editGuidance' | translate"
                      [maxLength]="2000" />
                  </div>
                </div>
                @let yesNoQuestions = getYesNoQuestions(section, areaIndex);
                @if (yesNoQuestions.length > 0) {
                  <div class="depends-on-container">
                    @let dependsOn = getControl(area, "dependsOn");
                    <sag-ui-select [formControl]="dependsOn" [label]="'template.item.dependsOn' | translate" [required]="true">
                      <sag-ui-option [value]="-1">{{ "generic.filter.none" | translate }}</sag-ui-option>
                      @for (question of yesNoQuestions; track question.idx) {
                        <sag-ui-option [value]="question.idx + 1">
                          {{ question.idx + 1 }} - {{ question.area.controls.description.value | slice: 0 : 50 }}
                        </sag-ui-option>
                      }
                    </sag-ui-select>
                    @if (dependsOn.value !== -1) {
                      <sag-ui-select [formControl]="getControl(area, 'dependsOnAnswer')" [required]="true" [label]="'template.item.dependsOnAnswer' | translate">
                        <sag-ui-option [value]="YesNoEnum.Yes">{{ "generic.truthy.true" | translate }}</sag-ui-option>
                        <sag-ui-option [value]="YesNoEnum.No">{{ "generic.truthy.false" | translate }}</sag-ui-option>
                      </sag-ui-select>
                    }
                  </div>
                }
                <div class="question-actions">
                  <button
                    #addGuidanceButton
                    (click)="toggleGuidanceText(addGuidanceButton, addGuidanceArea, area)"
                    [ngClass]="{ hide: hasGuidanceValue(area) }"
                    class="question-action-button primary"
                    type="button">
                    {{ "template.item.addGuidance" | translate }}
                  </button>
                  <sag-ui-button
                    icon="delete"
                    color="danger"
                    (click)="removeQuestion(activeSectionIndex, areaIndex)"
                    class="question-action-button cancel"
                    [ngClass]="{ hide: hasGuidanceValue(area) }"
                    type="button">
                    {{ "template.item.removeQuestion" | translate }}
                  </sag-ui-button>
                </div>
              </div>
            }
            <div class="section-footer">
              <sag-ui-button icon="plus-large" color="secondary" type="button" (click)="addQuestion(activeSectionIndex, questionType.text)">
                {{ "template.item.text" | translate }}
              </sag-ui-button>
              <sag-ui-button icon="plus-large" color="secondary" type="button" (click)="addQuestion(activeSectionIndex, questionType.yesNo)">
                {{ "template.item.yesNo" | translate }}
              </sag-ui-button>
              <sag-ui-button icon="plus-large" color="secondary" type="button" (click)="addQuestion(activeSectionIndex, questionType.value)">
                {{ "template.item.value" | translate }}
              </sag-ui-button>
            </div>
          </div>
        </ng-container>
      </div>

      <sag-ui-button class="add-section" icon="plus-large" color="secondary" type="button" (click)="addSection()">
        {{ "template.item.addSection" | translate }}
      </sag-ui-button>
    </div>
  </div>
</div>
